import { combineReducers } from 'redux';
import siteMenuSlice from './site-menu/siteMenuSlice';

export default combineReducers({
    siteMenu: siteMenuSlice,
});
